import React, { useEffect } from 'react'
import { useLang } from '../lib/useLang'
import './Landing.css'
import './PublicPage.css'

/**
 * Универсальная страница юридического документа.
 * Рендерит структуру t(`${docKey}.sections`) — массив { id, title, content[], items[], footer }.
 * Используется для termsPage / consentPage / cookiePage (и совместима с privacyPage).
 *
 * @param {{ docKey: string }} props - ключ документа в локали
 */
export default function LegalPage({ docKey }) {
  const { t } = useLang()
  const sections = t(`${docKey}.sections`)

  useEffect(() => {
    window.scrollTo(0, 0)
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target) } }),
      { threshold: 0.08 }
    )
    document.querySelectorAll('[data-reveal]').forEach((el) => observer.observe(el))
    return () => observer.disconnect()
  }, [docKey])

  return (
    <div className='public-page'>
      <div className='public-hero'>
        <div className='public-hero-inner'>
          <div data-reveal className='public-tag'>{t(`${docKey}.tag`)}</div>
          <h1 data-reveal className='public-hero-title' style={{ transitionDelay: '0.1s' }}>
            {t(`${docKey}.title`)}
          </h1>
          <p data-reveal className='public-hero-sub' style={{ transitionDelay: '0.2s' }}>
            {t(`${docKey}.effectiveDate`)}
          </p>
        </div>
      </div>

      <div className='public-content'>
        <div className='public-content-inner'>
          {Array.isArray(sections) && sections.map((section, i) => (
            <div key={section.id} data-reveal className='privacy-section' style={{ transitionDelay: `${i * 0.05}s` }}>
              <div className='privacy-section-num'>{section.id}</div>
              <div className='privacy-section-body'>
                <h2 className='privacy-section-title'>{section.title}</h2>

                {section.content?.map((p, j) => (
                  <p key={j} className='privacy-p'>{p}</p>
                ))}

                {section.items && (
                  <ul className='privacy-items'>
                    {section.items.map((item, j) => (
                      <li key={j} className='privacy-item'>
                        <span className='privacy-item-dot' />
                        <div>
                          <span className='privacy-item-label'>{item.label} — </span>
                          <span className='privacy-item-desc'>{item.desc}</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}

                {section.footer && (
                  <p className='privacy-footer-note'>{section.footer}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
